module.exports = __webpack_public_path__ + "img/ test.25ceab7d.svg";